import { render } from "./TopSellingCategories.vue?vue&type=template&id=da7431f8&scoped=true"
import script from "./TopSellingCategories.vue?vue&type=script&lang=js"
export * from "./TopSellingCategories.vue?vue&type=script&lang=js"

import "./TopSellingCategories.vue?vue&type=style&index=0&id=da7431f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7431f8"]])

export default __exports__